import React from 'react';
import PropTypes from "prop-types";
import {convertirModena, formatFecha} from "../../../../shared/utils/utils";
import './FondoPrestacion.scss'


export const FondoPrestacion = ({datafondo}) => {

    let prestaciones = (datafondo.length > 0 ? datafondo[0].prestaciones : []);
    let dataCenta = (datafondo.length > 0 ? datafondo[0].cuenta : []);
    let datainfoRep = (datafondo.length > 0 ? datafondo[0] : []);
    let arrayTotales = [];
    let total = 0;
    if (datafondo.length > 0) {

        for (const pago of datafondo) {
            if (pago.prestaciones.length > 0) {
                for (const pago1 of pago.prestaciones) {
                    total += parseInt(pago1.valor)
                }
            }
            arrayTotales.push(total)
        }
    }


    function sumaCompensacion(fields) {
        let comarra = [];
        for (const refElement of fields) {
            comarra = [...comarra, ...refElement['prestaciones']]
        }
        const groups = new Set(comarra.map(item => item.descripcion));

        let obje = {};
        groups.forEach(g => {
            obje[g] = [];
            for (const el of comarra) {
                if (g === el.descripcion) {
                    obje[g] = [...obje[g], el]
                }
            }
        })
        let objeSuma = {};
        for (const refKey in obje) {
            objeSuma[refKey] = 0;

            for (const refElement of obje[refKey]) {
                if (refElement.descripcion === refKey) {
                    objeSuma[refKey] += refElement['valor']
                }
            }

        }
        return Object.keys(objeSuma).map(function (key) {
            return [key, objeSuma[key]];
        });
    }
    const initialValue = 0;

    let totalesCom =  sumaCompensacion(datafondo);

    const SumaTotales  = arrayTotales.reduce(
        (previousValue, currentValue) => previousValue + currentValue,
        initialValue
    );


    return (
        <div className="container px-10 fondos" >
            <div className="header-cont  hidden" style={{width: "100%"}}>
                <h1 style={{marginLeft:"25%", fontSize: "20pt",}}>FONDOS</h1>
                <img alt={"toa"} src="/img/toa.png" style={{marginTop:"10px", height:"auto", width:"10%"}}/>
            </div>

            <div className='row informacion py-2 my-1'>
                <div className=" mt-2 info-text lg:w-3/12 px-4">
                    <strong> Cédula: </strong> <span className="text-xs">{dataCenta.num_doc}</span>
                </div>
                <div className=" mt-2 info-text lg:w-6/12 px-4">
                    <strong> Nombre: </strong> <span className="text-xs"> {dataCenta.nombre}</span>
                </div>
                <div className=" mt-2 info-text lg:w-3/12 px-4">
                    <strong> Fecha pago: </strong> <span className="text-xs"> {formatFecha(datainfoRep.fecha)}</span>
                </div>
            </div>

            <table className="items-center w-full bg-transparent border-collapse">
                <thead>
                <tr>
                    <th
                        className={
                            "px-2 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left   "

                        }
                    >
                        Periodo
                    </th>
                    <th
                        className={
                            "px-2 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left   "

                        }
                    >
                        Institución
                    </th>

                    {(prestaciones.length > 0) && prestaciones.map(((data, i) => <th
                        className={
                            "px-2 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"

                        }
                        key={i}>{data['descrip_abrev']}</th>))}
                </tr>
                </thead>
                <tbody>
                {(datafondo.length > 0) && datafondo.map((info, i) => {

                    return <tr key={i}>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                <span className="ml-3 font-bold text-blueGray-600">
                                  {`${info.anio}/ ${info.mes} / P.${info.periodo}`}
                                </span>
                        </td>
                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs text-left whitespace-nowrap p-4 " style={{textAlign: "left",}}>
                                <span className="ml-3 font-bold text-blueGray-600 text-left">
                                  {info.nombre}
                                </span>
                        </td>

                        {(info['prestaciones'].length > 0) && info['prestaciones'].map(((data, i) => <td
                            className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 "
                            key={i}><span
                            className="ml-4 font-bold text-blueGray-600">{convertirModena(data['valor'])} </span>
                        </td>))}
                    </tr>
                })}

                </tbody>
                <tfoot>
                <tr>
                    <td className="px-2 align-middle total-texto border-gray-500 text-left border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold" style={{textAlign: "left !important",}}>TOTALES</td>
                    <td className="px-2 align-middle total-partner border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold "></td>

                   {totalesCom.length > 0 && totalesCom.map(((data, i) => <td
                        className="px-4 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color "
                        key={i}>{convertirModena(data[1])}
                    </td>))}
                </tr>
                </tfoot>
            </table>
        </div>
    );
};

FondoPrestacion.prototype = {
    datafondo: PropTypes.array,
}

FondoPrestacion.defaultProps = {
    datafondo: [],

}

